import { InstrumentCreateRequest, InstrumentEntity, InstrumentTypeEntity, InstrumentValidationEnum } from "../domain/entities/InstrumentEntity";


export const enrichInstrument = (
    request: InstrumentCreateRequest,
    id: string,
    createdAt: Date,
    updatedAt: Date | null,
    context: {
        instrumentTypes?: InstrumentTypeEntity[];
    }
): InstrumentEntity | null => {
    const {
        instrumentTypes = [],
    } = context;

    const instrumentType = instrumentTypes.find((it) => it.id.toString() === request.instrumentType);

    if (!instrumentType) return null;

    return {
        id,
        instrumentType,
        mnemonic: request.mnemonic,
        isin: request.isin,
        currency: request.currency,
        interestRate: request.interestRate,
        frequency: request.frequency,
        issuanceDate: request.issuanceDate,
        maturityDate: request.maturityDate,
        issuerName: request.issuerName,
        rating: request.rating,
        validation: request.validation ? request.validation as unknown as InstrumentValidationEnum : undefined,
        createdAt,
        updatedAt,
    };
}


export const mapToFormValues = (entity?: InstrumentEntity) =>
    entity
        ? {
            id: entity.id.toString(),
            mnemonic: entity.mnemonic.toString(),
            instrumentType: entity.instrumentType.id.toString(),
            isin: entity.isin.toString(),
            currency: entity.currency.toString(),
            interestRate: entity.interestRate.toString(),
            frequency: entity.frequency.toString(),
            issuanceDate: entity.issuanceDate.toString(),
            maturityDate: entity.maturityDate.toString(),
            issuerName: entity.issuerName.toString(),
            rating: entity.rating.toString(),
        }
        : undefined;
